/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

// import {ScheduleFilterPage} from "../pages/schedule-filter/schedule-filter";
// import {EventJudgesPage} from "../pages/event-judges/event-judges";
// import {InformationPopoverPage} from "../pages/information-popover/information-popover";
// import {ProgramStudiosPage} from "../pages/program-studios/program-studios";
// import {FindEventPage} from "../pages/find-event/find-event";

export const PageRefs = {
  addConnections: {
    name: 'AddConnectionsPage'
  },
  addGroupMembers: {
    name: 'AddGroupMembersPage',
    params: {
      groupId: 'PARAM_GROUP_ID'
    }
  },
  announcementFull: {
    name: 'AnnouncementFullPage',
    params: {
      eventId: 'eventId',
      announcementId: 'announcementId',
      title: 'title'
    }
  },
  awardsByType: {
    name: 'AwardsByTypePage',
    params: {
      awardType: 'PARAM_AWARD_TYPE'
    }
  },
  awardsLanding: {
    name: 'AwardsLandingPage'
  },
  conversation: {
    name: 'ConversationPage',
    param: {
      participantId: 'PARAM_PARTICIPANT_ID',
      conversationId: 'PARAM_CONVERSATION_ID',
      conversationName: 'PARAM_CONVERSATION_NAME'
    }
  },
  entryDetails: {
    name: 'EntryDetailsPage',
    help: 'entryDetails',
    params: {
      entryId: 'PARAM_ENTRY'
    }
  },
  eventAdjudicators: {
    name: 'EventJudgesPage',
    params: {
      eventId: 'PARAM_EVENT'
    }
  },
  eventDetails: {
    name: 'EventJudgesPage'
  },
  eventSchedule: {
    name: 'EventSchedulePage',
    help: 'tabEventSchedule',
    params: {
      event: 'PARAM_EVENT'
    }
  },
  eventTabs: {
    name: 'EventTabsPage',
    params: {
      notification: 'PARAM_NOTIFICATION'
    }
  },
  feed: {
    name: 'FeedPage'
  },
  groupConversation: {
    name: 'GroupConversationPage',
    params: {
      groupId: 'PARAM_GROUP_ID'
    }
  },
  groupDetails: {
    name: 'GroupDetailsPage',
    params: {
      groupId: 'PARAM_GROUP_ID'
    }
  },
  findEvent: {
    name: 'FindEventPage',
    help: 'findEvent'
  },
  help: {
    name: 'HelpPage',
    params: {
      topic: 'PARAM_TOPIC'
    }
  },
  home: {
    name: 'HomePage',
    help: 'home'
  },
  informationPopover: {
    name: 'InformationPopoverPage'
  },
  login: {
    name: 'LoginPage'
  },
  messaging: {
    name: 'MessagingPage'
  },
  morePopover: {
    name: 'MorePopoverPage'
  },
  myEvents: {
    name: 'MyEventsPage',
    help: 'myEvents'
  },
  profile: {
    name: 'ProfilePage',
    help: 'profile'
  },
  programAgeCategories: {
    name: 'ProgramAgeCategoriesPage'
  },
  programEntryAwards: {
    name: 'ProgramEntryAwardsPage'
  },
  programEntryCategories: {
    name: 'ProgramEntryCategoriesPage'
  },
  programEntryClassifications: {
    name: 'ProgramEntryClassificationsPage'
  },
  programEntryTypes: {
    name: 'ProgramEntryTypesPage'
  },
  programMedallions: {
    name: 'ProgramMedallionsPage'
  },
  programStudios: {
    name: 'ProgramStudiosPage'
  },
  scheduleDetailSplit: {
    name: 'ScheduleDetailSplitPage'
  },
  scheduleFilterPage: {
    name: 'ScheduleFilterPage',
    help: 'scheduleFilter',
    params: {
      filters: 'filters'
    }
  },
  scheduleSplitPage: {
    name: 'ScheduleSplitPage'
  }
};

export interface ScheduleFilterOptions {
  ages: {},
  types: {},
  categories: {},
  classifications: {},
  medals: {},
  isEnabled: boolean,
  isShowBreaks: boolean,
  isIncludeStudios: boolean,
  isIncludeDancers: boolean,
  searchText?: string
}



// WEBPACK FOOTER //
// ./src/shared/PageRefs.ts